import './GlobalRanking.css';

import React from 'react';
import PropTypes from 'prop-types';
import padStart from 'lodash/padStart';
import config from '@config';

import { Table } from 'antd';
import { eventHandler, GAAction } from '@analytics';
import Link from 'redux-first-router-link';
import ShareScore from './ShareScore';

export const getColumns = (isTop10, total) => [
  {
    title: '#',
    dataIndex: 'rank',
    className: 'column-rank',
    key: 'participant-rank',
    render: (rank) => <span>{rank}</span>,
  },
  {
    title: isTop10 ? (
      <div>
        Top 10 Participantes <span className="from-all">(de {total})</span>
      </div>
    ) : (
      <div>Mi Puntaje</div>
    ),
    dataIndex: 'username',
    className: 'column-username',
    key: 'participant-username',
    render: (username, { userId, me, score }) => (
      <div className="ranking-user-cell">
        <Link
          to={['mundial-ideal', userId]}
          onClick={eventHandler(GAAction.ClickOnRankingUser)}
        >
          <span>{username}</span>
        </Link>
        {me && <ShareScore userId={userId} username={username} score={score} />}
      </div>
    ),
  },
  {
    title: isTop10 && 'Puntos',
    dataIndex: 'score',
    className: 'column-score',
    width: '60px',
    align: 'center',
    key: 'participant-score',
    render: (score) => padStart(score, config.scoreDigits, '0'),
  },
];

export const isMySelf = ({ me }) => (me ? 'me' : '');

export const GlobalRanking = ({ total, top, myRange, showRange }) => (
  <div className="GlobalRanking ranking-container">
    <Table
      columns={getColumns(true, total)}
      dataSource={top}
      rowKey="userId"
      pagination={false}
      rowClassName={isMySelf}
    />
    {showRange && (
      <Table
        id="range-table"
        columns={getColumns(false)}
        dataSource={myRange}
        rowKey="userId"
        pagination={false}
        rowClassName={isMySelf}
      />
    )}
  </div>
);

GlobalRanking.displayName = 'GlobalRanking';
GlobalRanking.propTypes = {
  total: PropTypes.number,
  top: PropTypes.array,
  myRange: PropTypes.array,
  showRange: PropTypes.bool,
};

GlobalRanking.defaultProps = {
  total: 0,
  top: [],
  myRange: [],
  showRange: false,
};

export default GlobalRanking;
